import { unionBy } from 'lodash/fp';

import { DEFAULT_PAGE_SIZE } from 'dashboard/lib/constants/pagination';
import { TableState } from 'dashboard/lib/interfaces/TableState';
import { List, ListStatus } from 'dashboard/models/list';
import { User } from 'dashboard/models/user';
import { ListsActions, ListsActionType, ListsFilterParams } from 'dashboard/redux/actions/lists';

export type Lists = Record<string, List[]>;

export interface ListsState extends TableState<ListsFilterParams> {
  lists: List[];
  users: User[];
}

export const initialListsFilterParams = {
  status: [ListStatus.Active],
};

export const initialListsState: ListsState = {
  lists: [],
  users: [],
  sortParams: {
    sort: 'created-at',
    shouldSortDescending: true,
  },
  filters: initialListsFilterParams,
  paginationParams: undefined,
  pageSize: DEFAULT_PAGE_SIZE,
  currentPage: 1,
};

export default (state: ListsState = initialListsState, action: ListsActions) => {
  switch (action.type) {
    case ListsActionType.SetLists: {
      return {
        ...state,
        lists: action.payload.lists,
      };
    }

    case ListsActionType.SetList: {
      return {
        ...state,
        lists: unionBy('id', [action.payload.list], state.lists),
        users: unionBy('id', [action.payload.user], state.users),
      };
    }

    case ListsActionType.SetListsDetails: {
      return {
        ...state,
        users: action.payload.users,
      };
    }

    case ListsActionType.SetListsSortParams: {
      return {
        ...state,
        sortParams: {
          ...action.payload.sortParams,
        },
      };
    }

    case ListsActionType.SetListsFilters: {
      return {
        ...state,
        filters: {
          ...action.payload.filters,
        },
      };
    }

    default:
      return state;
  }
};
